import {
  params, shape, string, number, bool, arrayOf, extend
} from '@thd-nucleus/data-sources';
import { dataModel as listDataModel } from '@thd-olt-component-react/list-tile';

const list = shape(listDataModel.list);

export const dataModel = extend({
  lists: params({ page: number(), pageSize: number() }).shape({
    pagination: shape({
      pageSize: number(),
      totalResults: number(),
      totalPages: number(),
      hasMore: bool()
    }),
    results: arrayOf(list)
  })
}, listDataModel);
